import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import {withStyles, Typography, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails} from '@material-ui/core'
import ExpandMore from '@material-ui/icons/ExpandMore'

const styles = {
    container: {
        flex: 1,
        borderTop: '1px solid #d6d6d6'
    },

    title: {
        flex: 1
    },

    badge: {
        marginRight: '3em',
        backgroundColor: 'green',
        color: '#fff',
        borderRadius: '0.3em',
        padding: '0.3em'
    },

    redBadge: {
        backgroundColor: 'red'
    },

    root: {
        '&$disabled': {
            opacity: 0.8,
            cursor: 'not-allowed',
            backgroundColor: 'inherit'
        }
    },
    disabled: {}
}

const Expandable = function({classes: styles, icon, title, children, className, badgeText, badgeClassName, disabled}) {
    return (
        <ExpansionPanel className={styles.container} disabled={disabled} classes={{root: styles.root,  disabled: styles.disabled}}>
            <ExpansionPanelSummary expandIcon={<ExpandMore />}>
                {icon}
                <Typography className={styles.title} variant="body1" color="inherit">{title}</Typography>
                <Typography style={{paddingRight: '0.3em'}} className={classNames(styles.badge, disabled && styles.redBadge, badgeClassName)} variant="caption" color="inherit">{badgeText}</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails className={className}>
                {children}
            </ExpansionPanelDetails>
        </ExpansionPanel>
    )
}

Expandable.propTypes = {
    classes: PropTypes.object,
    className: PropTypes.string,
    icon: PropTypes.element,
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired,
    title: PropTypes.string.isRequired,
    badgeText: PropTypes.string,
    badgeClassName: PropTypes.string,
    disabled: PropTypes.bool
}

Expandable.defaultProps = {
    disabled: false
}

export default withStyles(styles)(Expandable);
